/* RESPONSIBLE TEAM: team-frontend-tech */
import { isArray } from '@ember/array';
import { dasherize } from '@ember/string';
import Predicate from 'predicates/models/predicate';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
const KNOWN_UNKNOWN_REGEX = /^(un)?known$/;
export default EmbercomBaseSerializer.extend({
  attrs: {
    subclass: {
      serialize: false
    }
  },
  normalize(modelClass, resourceHash) {
    let updates = {};
    let result = this._super(...arguments);
    if (KNOWN_UNKNOWN_REGEX.test(result.data.attributes.comparison) && result.data.attributes.value) {
      updates.value = null;
    }
    updates.subclass = `predicates/${dasherize(Predicate.getGenericType(result.data.attributes.type))}`;
    if (isArray(resourceHash.predicates)) {
      let normalizedSubPredicates = [];
      resourceHash.predicates.forEach(predicate => {
        normalizedSubPredicates.push(this.normalize(modelClass, predicate).data.attributes);
      });
      updates.predicates = normalizedSubPredicates;
    }
    Object.assign(result.data.attributes, resourceHash, updates);
    return result;
  }
});